import { ReadonlyRepositoryObjectService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { Fattener } from '../types/fattener.model';
import { FattenerQuery } from '../types/fattener-query';
import { FattenerRepository } from '../repositories/fattener.repository';
import { UserInfoService } from '@softline/auth';
import { SoftAppsUserInfo } from '@softapps/core';

@Injectable()
export class FattenerService extends ReadonlyRepositoryObjectService<
  Fattener,
  Result<Fattener>,
  FattenerQuery | undefined
> {

  private readonly userInfo = inject<UserInfoService<SoftAppsUserInfo>>(UserInfoService);

  override params = computed(() => {
    const accountid = this.userInfo.value()?.accountid;

    if (!accountid) {
      return undefined;
    }

    return { id: accountid };
  });

  constructor() {
    super(inject(FattenerRepository));
  }

  protected override getValue(result: Result<Fattener>): Fattener {
    return result.result;
  }
}
